import React from "react";
import { Link } from "react-router-dom";

const PreviewButton = ({ preview }) => (
  <div className="btn-group">
    <Link
      className="btn btn-form btn-with-icon"
      to={preview ? "/editor" : "/preview"}
    >
      {preview ? (
        <>
          <i className="fi fi-return"></i>
          { i18n.t('header.edit') }
        </>
      ) : (
        <>
          <i className="fa fa-eye"></i>
          { i18n.t('header.preview') }
        </>
      )}
    </Link>
  </div>
);

export default PreviewButton;
